import React from "react";

interface IconProps {
    className?: string;
  }

const HDIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width="875px"
    height="389px"
    viewBox="0 0 875 389"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>hd-sign</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="hd-sign" fill="#000000" fillRule="nonzero">
        <path d="M260.020498,389 L303.189423,237.838922 L142.074125,237.838922 L98.8879124,389 L0,389 L111.105207,0 L210.019049,0 L164.300352,160.047567 L325.407007,160.047567 L371.125704,0 L470.04819,0 L358.917053,389 L260.020498,389 Z M866.20487,194.5 C833.343071,309.5273 725.068543,389 600.056278,389 L436.715332,389 L510.122817,131.996344 L609.010729,131.996344 L558.153595,310.067578 L628.713115,310.067578 C689.276668,310.067578 745.950738,263.400544 765.467293,195.066211 C785.152392,126.148378 753.085776,78.9237778 690.300898,78.9237778 L525.265866,78.9237778 L547.811895,0 L715.05961,0 C837.297378,0 899.20064,78.9237778 866.20487,194.5 Z" id="_x34_9-HD_icon" />
      </g>
    </g>
  </svg>
);

export default HDIcon;
